import React from "react";
import secondaryComponents from "../../../../components/secondaryComponents";
import primaryComponents from "../../../../components/primaryComponents";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { motion } from "framer-motion";
import styles from "./styles.module.scss";
import globalStyles from "../../../../assets/styles/base/globalPage.module.scss";
import { useJournalEntries } from "./useJournalEntries";
import { useNavigate } from "react-router-dom";
import { pathConstants } from "../../../../routes/pathContants";

const JournalEntries = () => {
  const { journalTabs, selectedTab, updateSelectedTab } = useJournalEntries();
  const navigate = useNavigate();
  let isLoadingAccount = false;

  return (
    <secondaryComponents.MetaSetter
      title="Lumi Merchant | Account Settings"
      description="Manage your account settings, including VAT preferences and store configurations"
    >
      <secondaryComponents.LoaderHelper classNames="mt-4">
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          className={`${styles.journals} ${globalStyles.pageColumnGaps}`}
        >
          <div>
            <h4 className="mb-0">Journal Entries</h4>
            <p>
              Keep track of your financial records and ensure accurate
              bookkeeping with our journal entry management system.
            </p>

            <div className="mt-3">
              <div className={`${globalStyles.rowSpaceBetween}`}>
                <div
                  className={`${globalStyles.rowNavigations} mb-4`}
                  style={{ width: "60%" }}
                >
                  {journalTabs?.map((item, index) => {
                    const key = item?.key;
                    return (
                      <React.Fragment key={index}>
                        <secondaryComponents.NavigateWithPermission
                          permissionParentKey="Accounting"
                          showOnLocalSetup={item?.showOnLocalSetup}
                        >
                          {/* eslint-disable-next-line */}
                          <a
                            className={`${globalStyles.rowNavigations__item} ${
                              key === selectedTab ? globalStyles.active : ""
                            }`}
                            onClick={() => {
                              updateSelectedTab(key);
                            }}
                          >
                            {item?.label}
                          </a>
                        </secondaryComponents.NavigateWithPermission>
                      </React.Fragment>
                    );
                  })}
                </div>
                <div className="d-flex" style={{ gap: "10px" }}>
                  <primaryComponents.Button
                    classNames="btn btn--primary"
                    onClick={() => {
                      navigate(pathConstants.ACCOUNTING_CREATE_JOURNAL_ENTRY);
                    }}
                  >
                    <FontAwesomeIcon icon={faPlus} className="mr-2" />
                    Create Journal
                  </primaryComponents.Button>
                </div>
              </div>
              <div
                className={`${globalStyles.tableWrapper} ${styles.journals__tabs}`}
              >
                <secondaryComponents.LoaderHelper
                  isLoading={isLoadingAccount}
                  classNames={"pt-5"}
                >
                  {selectedTab === "all_entries_tab" && (
                    <secondaryComponents.JournalEntriesTab journalStatus="" />
                  )}
                  {selectedTab === "posted_tab" && (
                    <secondaryComponents.JournalEntriesTab journalStatus="POSTED" />
                  )}
                  {selectedTab === "draft_tab" && (
                    <secondaryComponents.JournalEntriesTab journalStatus="DRAFT" />
                  )}
                  {selectedTab === "review_tab" && (
                    <secondaryComponents.JournalEntriesTab journalStatus="IN_REVIEW" />
                  )}
                  {selectedTab === "voided_tab" && (
                    <secondaryComponents.JournalEntriesTab journalStatus="VOIDED" />
                  )}
                  {selectedTab === "cancelled_tab" && (
                    <secondaryComponents.JournalEntriesTab journalStatus="CANCELED" />
                  )}
                </secondaryComponents.LoaderHelper>
              </div>
            </div>
          </div>
        </motion.div>
      </secondaryComponents.LoaderHelper>
    </secondaryComponents.MetaSetter>
  );
};

export default JournalEntries;
